<div *ngIf="isSelected()" id="{{tabId}}">
    <ng-content></ng-content>
</div>
